import { isNumber } from './isNumber';

export const getMinimalNumber = (
  ...values: Array<number | undefined | null>
) => {
  const numbers = values.filter(isNumber);
  return Math.min(...numbers);
};
